// 初期表示
export const PAGE_INIT = "corp/valuation/beta/PAGE_INIT";
// グラフ更新
export const UPDATE_GRAPH = "corp/valuation/beta/UPDATE_GRAPH";
